import { format } from 'date-fns';

// YYYYMMDD_HHMMSS
export const getFileName = (date = new Date()): string => {
	return format(date, 'yyyyMMdd_HHmmss');
};
